module.exports = {
  title: '云翼物联Sim卡管理平台',

  showSettings: true,

  //tagsView: false,

  fixedHeader: false,

  sidebarLogo: false,

  //errorLog: 'production'
}



// WEBPACK FOOTER //
// ./src/settings.js